<template>
	<div>
		<el-table :data="details">
			<el-table-column label="Nội dung" prop="noi_dung" min-width="250">
				<template #default="scope">
					{{ scope.row.noi_dung }}
				</template>
			</el-table-column>
			<el-table-column label="Số liệu" prop="so_tien" min-width="150">
				<template #default="scope">
					{{ formatPrice(scope.row.so_tien) }}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {formatPercent, formatVND} from "../../../../core/filters";

export default {
	name: "BackOfficeDetail",
	props: {
		details: {
			type: Array,
			default: [],
		}
	},
    mounted() {
        console.log(this.details, 'details');
    },
	methods: {
		formatPrice(item) {
			if (typeof item == 'string' && item.search('đ')) {
				return item;
			} else {
				return formatVND(item);
			}
		},
		formatPercent(item) {
			if (typeof item == 'string' && item.search('%')) {
				return item;
			} else {
				return formatPercent(item);
			}
		},
	},
}
</script>

<style scoped>

</style>